module.exports = __webpack_public_path__ + "static/media/user-space.1dea48c5.gif";